<app-header title="Tickets" *ngIf="isExternal === false"></app-header>

<ion-content>
  <div class="ext-header" *ngIf="isExternal === true">
    <img src="./assets/image/cb-logo.png"/>
  </div>

  <div class="content-wrapper" class="ion-padding">
    <div class="flex-spaced mb10px">
      <h2><ion-icon *ngIf="isExternal === false" name="arrow-back-outline" (click)="back()" class="back-arrow"></ion-icon> Support Ticket</h2>
      <div *ngIf="isExternal === false" class='flex-end flex-gap'>
        <ion-button *ngIf="tickets != null && tickets.length > 0" color="danger" (click)="delete()">Delete</ion-button>
        <app-select-input *ngIf="tickets != null && tickets.length > 0" [disabled]="tickets[0].status == SupportStatus.Closed"
          [(ngModel)]="tickets[0].assignedUserId" label="Assigned To" placeholder="Selected Assignee" [options]="[
          { value: 9550, displayValue: 'Dave'},
          { value: 9547, displayValue: 'Morgan'},
          { value: 9818, displayValue: 'Ross'},
          { value: 9859, displayValue: 'Klaus'}
        ]" (changed)="assign()"></app-select-input>
        <ion-button *ngIf="tickets != null && tickets.length > 0 && tickets[0].status != SupportStatus.Closed" (click)="saveStatus(SupportStatus.Closed)">Close</ion-button>
        <ion-button *ngIf="tickets != null && tickets.length > 0 && tickets[0].status == SupportStatus.Closed" color="medium" (click)="saveStatus(SupportStatus.New)">Re-Open</ion-button>
      </div>
      </div>
    <app-skeleton *ngIf="loaded == false"></app-skeleton>
    
    <ng-container *ngIf="loaded == true">

      <!-- Renders first, main ticket, and subsequent tickets (being responses) with certain fields not
           shown, i.e. status only makes sense on the original ticket -->
      <div class="ticket" *ngFor="let ticket of tickets">
        <div class="details">
          <h4>{{ticket.subject}}</h4>
          <div class="from">
            Submitted by {{ticket.userEmail}} on {{ticket.timestampObj | luxon}}
          </div>
          <div [innerHtml]="ticket.body"></div>
        </div>
        <div class="attachments">
          
          <div class="attachment" *ngFor="let a of ticket.attachmentPaths" (click)="download(a)">
            <img *ngIf="a.endsWith('.png') || a.endsWith('.jpg') || a.endsWith('.jpeg') || a.endsWith('.gif') || a.endsWith('.webp')" [src]="a"/>
            <ion-icon *ngIf="!a.endsWith('.png') || a.endsWith('.jpg') || a.endsWith('.jpeg') || a.endsWith('.gif') || a.endsWith('.webp')"
              name="cloud-download-outline"></ion-icon>
            <p>{{a.substring(a.lastIndexOf('/')+1)}}</p>
          </div>

        </div>
      </div>

      <div class="ticket" *ngIf="newTicket != null">
        <div class="details">
          
          <app-text-input [(ngModel)]="newTicket.subject" [required]="true" label="Subject" [maxLength]="250" 
            placeholder="Enter subject"></app-text-input>
    
          <app-text-input [(ngModel)]="newTicket.userEmail" [required]="true" label="Email" [maxLength]="250" 
            placeholder="Enter email" [spellcheck]="false"></app-text-input>

          <app-select-input *ngIf="isL57Admin && this.tickets.length == 0"
            [(ngModel)]="newTicket.targetProduct" label="For Product" placeholder="Selected Product" [options]="[
            { value: 1, displayValue: 'CommuniBee'},
            { value: 3, displayValue: 'Raffle Rocket'},
            { value: 2, displayValue: 'Bid Beacon'}
            ]"></app-select-input>

          <div class="froala-div"  class="mtb20px">
            <div #froala [froalaEditor]="froalaOptions" [(froalaModel)]="newTicket.body" class="wysiwyg-editor"></div>
          </div>

          <div class="flex-spaced">
            <div></div>
            <ion-button (click)="save()">Save</ion-button>
          </div>
        </div>
        <div class="attachments">
          <h3>Select Attachments</h3>
          <input #fileInput type="file" (change)="onFileSelected($event)" multiple>
        </div>
      </div>





    </ng-container>

  </div>

</ion-content>